import styled,{ keyframes }  from 'styled-components';


const move = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;
// const move = keyframes`
//     0% {
//         transform: rotate(0);
//         animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
//       }
//       50% {
//         transform: rotate(900deg);
//         animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
//       }
//       100% {
//         transform: rotate(1800deg);
//       }

//     `;

    
export const Hourglass = styled.div`
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #ED5D39;
    width: 120px;
    height: 120px;
    animation: ${move} 2s linear infinite;
    // display: inline-block;
    // position: relative;
    // width: 180px;
    // height: 180px;
    // &:after{
    //     content: " ";
    //     display: block;
    //     border-radius: 50%;
    //     width: 0;
    //     height: 0;
    //     margin: 8px;
    //     box-sizing: border-box;
    //     border: 32px solid #ED5D39;
    //     border-color: #ED5D39 transparent #fff transparent;
    //     animation:${move} 2.5s ease infinite;
    // }
`;
export const Position = styled.div`
position: absolute;
height: 100px;
width: 100px;
top: calc(50% - 60px);
left: calc(50% - 60px);
background-size: 100%;
`